import React, { useState } from "react";
import User from '../../Assets/images/user.png'
import { toast } from "react-toastify";
import Compressor from 'compressorjs';
import Handler from '../../Helpers/Handler'
import { reloadWindow } from '../../Helpers/Utils'

const Profile = ({ requestKey }) => {
    const [loading, setLoading] = useState(false)
    const [profile, setProfile] = useState({ url: "", photo: "" })
    const handleImage = (event) => {
        setLoading(true)
        if (event.target.files[0]) {
            const file = event.target.files[0]
            new Compressor(file, {
                quality: 0.9,
                convertSize: 1 * 1024 * 1024,
                success(result) {
                    if (result.size > 4.5 * 1024 * 1024) return toast.error('Compressed image size exceeds 4.5 MB.');
                    setProfile({ url: URL.createObjectURL(result), photo: result })
                },
                error(err) {
                    toast.error(err.message);

                },
            });
        }
        setLoading(false)
    };
    const submit = async () => {
        if (!profile.photo) return toast.error("Please upload your profile")
        setLoading(true);
        const formData = new FormData()
        formData.append('photo', profile?.photo)
        const response = await Handler({ method: 'PATCH', url: `/customer/profile/${requestKey}`, data: formData, formData: true })
        if (response?.success) {
            toast.success(response.message || "Profile updated successfully")
            setTimeout(() => {
                reloadWindow()
                setLoading(false);
            }, 2000);
        } else {
            setLoading(false);
            toast.error(response?.message || "Unable to upload")
        }
    }
    return (
        <React.Fragment>
            <div className="d-flex align-items-center flex-column justify-content-center">
                <div className="profile-image">
                    <img src={profile?.url || User} alt="Profile" className="profile-image" />
                </div>
                <label htmlFor='profile' className="mt-3 upload-btn cursor-pointer"> {loading ? "Waiting..." : "Upload"}</label>
                <input type="file" accept="image/*" className="d-none" name="profile" id='profile' disabled={loading} onChange={(event) => handleImage(event)} />
            </div>
            <div className="text-center mt-4">
                <button className="btn btn-success" onClick={submit} disabled={loading}>{loading ? "Uploading..." : "Submit"}</button>
            </div>
        </React.Fragment>
    )
}

export default Profile